import { useState } from "react";
import RequiredDocumentsModal from "../onboarding/RequiredDocumentsModal";
import MissingDocument from "../onboarding/missingDocument";

const STEP_TO_NUMBER = {
  checks: 1,
  basic: 2,
  identity: 3,
  documents: 5,
  financial: 6,
  guarantor: 4,
};

const TenantChecksUploadDocument = ({
  formHandler,
  user,
  updateUserProfile,
  getNextStep,
  onComplete,
  selectedOnboardingUsers,
  setSelectedOnboardingUsers,
}) => {
  const [showMissing, setShowMissing] = useState(false);
  const [documentAnalysisResponse, setDocumentAnalysisResponse] = useState({});

  const advanceToNextStep = async () => {
    const nextId = getNextStep();
    if (!nextId) {
      await onComplete();
      return;
    }
    await updateUserProfile({
      id: user?._id,
      step: STEP_TO_NUMBER[nextId] ?? nextId,
    });
    formHandler.next();
  };

  if (showMissing) {
    return (
      <MissingDocument
        documentAnalysisResponse={documentAnalysisResponse}
        setDocumentAnalysisResponse={setDocumentAnalysisResponse}
        user={user}
        formHandler={{
          prev: () => setShowMissing(false),
          next: advanceToNextStep,
        }}
        selectedOnboardingUsers={selectedOnboardingUsers}
        setSelectedOnboardingUsers={setSelectedOnboardingUsers}
        updateUserProfile={updateUserProfile}
        isGuarantor={false}
        isEditMode={false}
        usedFor="tenantChecks"
      />
    );
  }

  return (
    <RequiredDocumentsModal
      user={user}
      formHandler={{ ...formHandler, next: () => setShowMissing(true) }}
      updateUserProfile={() => setShowMissing(true)}
      documentAnalysisResponse={documentAnalysisResponse}
      setDocumentAnalysisResponse={setDocumentAnalysisResponse}
      isGuarantor={false}
      needWaitingJobForClave={false}
      isEditMode={false}
      hideClave
      llCreated
      onClose={formHandler.prev}
    />
  );
};

export default TenantChecksUploadDocument;
